import {
  type RedblueApplicationRole,
  type RedblueCurrentUser,
  readRedblueCurrentUserApplicationRoles,
} from "./lib/redblue-api-contract";

const REDBLUE_ADMIN_ROLES: ReadonlySet<RedblueApplicationRole> = new Set([
  "exercise_manager",
  "platform_manager",
]);
const REDBLUE_ACCEPTANCE_ROLES: ReadonlySet<RedblueApplicationRole> = new Set(["platform_manager"]);

type InitialState = {
  currentUser?: RedblueCurrentUser | null;
};

function resolveApplicationRoles(currentUser: RedblueCurrentUser | null | undefined) {
  if (!currentUser) return [];
  return readRedblueCurrentUserApplicationRoles(currentUser);
}

function hasRedblueApplicationRole(
  currentUser: RedblueCurrentUser | null | undefined,
  allowedRoles: ReadonlySet<RedblueApplicationRole>,
) {
  if (!currentUser) return false;
  return resolveApplicationRoles(currentUser).some((role) => allowedRoles.has(role));
}

export function canAccessRedblueAdmin(user: RedblueCurrentUser | null | undefined) {
  return hasRedblueApplicationRole(user, REDBLUE_ADMIN_ROLES);
}

export function canAccessRedblueAcceptance(user: RedblueCurrentUser | null | undefined) {
  return hasRedblueApplicationRole(user, REDBLUE_ACCEPTANCE_ROLES);
}

export default function access(initialState: InitialState | undefined) {
  const currentUser = initialState?.currentUser ?? null;
  return {
    canAccessRedblueAdmin: hasRedblueApplicationRole(currentUser, REDBLUE_ADMIN_ROLES),
    canAccessRedblueAcceptance: hasRedblueApplicationRole(currentUser, REDBLUE_ACCEPTANCE_ROLES),
  };
}
